module.exports = __webpack_public_path__ + "static/img/组 9(2).c6e92440.png";